import { ReactElement, ReactNode } from "react"

export type ChipDropdownOption = {
  key: string
  label?: ReactNode
  icon?: ReactElement
  isDefault?: boolean
  dataCy?: string
}
